


















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Company, { COMPANY_ROLE } from "@/model/company";
import companyApi from "@/api/companyApi";
@Component({
  name: "qWitnessSelect",
  components: {},
  directives: {},
})
export default class QWitnessSelect extends Vue {
  @Prop()
  value;
  public companies: Company[] = [];
  public selected = null;

  @Prop({
    default: null,
    required: true
  })
  companyId;
  @Watch("companyId")
  changeCompanyId(newValue) {
    if (newValue) {
      this.selected = null;
      this.getList();
    } else {
      this.companies = [];
    }
  }
  @Watch('value')
  updateValue() {
    this.selected = this.value;
  }

  mounted() {
    this.getList();
    this.selected = this.value;
  }

  public changed($event) {
    this.$emit("input", this.selected);
    this.$emit(
      "change",
      $event.target.value
        ? this.companies.find(
          (item) => item.id === $event.target.value
        )
        : null
    );
  }

  public async getList() {
    const result = await companyApi.list({
      role_id: COMPANY_ROLE.WITNESS,
      mcCompanyId: this.companyId,
    });
    if (result) {
      this.companies = result;
    }
  }
}
